import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  .company-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 2px solid ${(props) => props.theme.$white};
    border-radius: 50%;
    background: ${(props) => props.theme.$gray300};
    color: ${(props) => props.theme.$gray800};
    font-size: 9px;
    font-weight: 700;
    line-height: 1;

    & + .company-initials {
      margin-left: -6px;
    }
  }

  &.databalloon[aria-label] {
    overflow: visible;
  }
`;
